var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3C14.4477 3 14 2.55228 14 2C14 1.44772 14.4477 1 15 1H22C22.5523 1 23 1.44772 23 2V9C23 9.55228 22.5523 10 22 10C21.4477 10 21 9.55228 21 9V4.41421L13.7071 11.7071C13.3166 12.0976 12.6834 12.0976 12.2929 11.7071C11.9024 11.3166 11.9024 10.6834 12.2929 10.2929L19.5858 3H15ZM4 6C3.44772 6 3 6.44772 3 7V20C3 20.5523 3.44772 21 4 21H17C17.5523 21 18 20.5523 18 20V13C18 12.4477 18.4477 12 19 12C19.5523 12 20 12.4477 20 13V20C20 21.6569 18.6569 23 17 23H4C2.34315 23 1 21.6569 1 20V7C1 5.34315 2.34315 4 4 4H11C11.5523 4 12 4.44772 12 5C12 5.55228 11.5523 6 11 6H4Z",
    fill: "#293644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoIcon);
export default __webpack_public_path__ + "static/media/gotoIcon.f4ba34b90184d01749870795a76ed2af.svg";
export { ForwardRef as ReactComponent };